module.exports = __webpack_public_path__ + "img/icon-sv3.a3949adf.png";